import { awsInit } from '$lib/aws/aws-init';
import { writable } from 'svelte/store';

export interface FormInfo {
	type: string;
	semesterId: null | number;
	programColorDark: null | string;
	perLessonPrice: number;
	numberOfTrialLessons: number | null;
	numberOfSkippableLessonsBeforeStart: number | null;
	name: string;
	address: null | FormInfoAddress;
	ageFrom: number;
	ageTo: number;
	autoEnrollmentAfterRegistration: boolean | null;
	classId: number | null;
	clientAddressRequired: boolean | null;
	collectDatesAndTimePreferences: boolean | null;
	collectPaymentInfo: boolean | null;
	collectStartDate: boolean | null;
	collectStudentInfo: boolean | null;
	colorLight: string | null;
	description: string | null;
	distinctLessons: null | FormInfoDistinctLesson[];
	dropInAvailable: boolean | null;
	enrollmentBlockBeforeHours: number | null;
	enrollmentCloseAfter: any;
	enrollmentCloseAfterLessonsCount: number;
	experienceLevels: string[];
	image: null | string;
	lessonDropInPrice: number | null;
	lessons: null | FormInfoLesson[];
	listOnBookingSite: boolean | null;
	offeringId: number | null;
	supportTrialLessons: boolean | null;
	program: string | null;
	upfrontPaymentRequired: boolean | null;
	orderNumber: number | null;
	calendarTitle: String;
	typeColorLight: String;
	typeColorDark: String;
	typeId: number;
	featureOnCalendar: boolean;
	calendarFeatureText: string;
	lessonsLeft: number | null;
	askPhotoConsent: boolean | null;
	bundles: null | Bundles[];
	seatsCount: number | null;
	seatsTaken: number | null;
	locationIds: number[] | null;
	showRegularPrice: boolean | null;
	sendConfirmationEmail: boolean | null
}

interface FormInfoAddress {
	address1: string;
	address2: null | string;
	country: string;
	state: string;
	city: string;
	zip: string;
}

interface FormInfoDistinctLesson {
	weekDay: string;
	classId: number;
	timeStart: string;
	timeEnd: string;
	tz: string;
	closestLessonEndDatetime?: string;
	closestLessonStartDatetime?: string;
}

interface FormInfoLesson {
	lessonId: number;
	classId: number;
	datetimeStart: string;
	formattedDatetimeStart: string;
	datetimeEnd: string;
	formattedDatetimeEnd: string;
	tz: string;
	orderNumber: number;
	durationFmt: string;
}

interface Bundles {
	id: number;
	name: string | null;
	description: string | null;
	moneyBaseValueDollar: number | null;
	lessonBaseValue: number | null;
	timeBaseValue: number | null;
	ticketTypeId: number | null;
	regularPriceDollar: number;
	sellPriceDollar: number;
}

awsInit();

// store
// hide undefined stage because we will make sure it loaded at layout level
const formInfo = writable<FormInfo>();

export const useFormInfo = () => {
	return {
		formInfo
	};
};
